import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class PlanningDashboardLanesRoute extends Route {
  async model() {
    const roadmap = this.modelFor('planning.dashboard');
    return RSVP.hash({
      roadmap,
      scenario: await roadmap.scenario,
    });
  }
}

export default instrumentRoutePerformance(PlanningDashboardLanesRoute);
